
import Vue from 'vue'
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);
  import $ from 'jquery'
  import {BACKEND_URL} from '../pages/GLOBALS'
  import router from '../routes/routes.js'
export default new Vuex.Store({
  state: {
    login: '',
    sessionId: '',
    status: false,
    errorLogin:'',
    restriction:0,
    vendeur:0
  },
  mutations: {
    login (state,login) {
      state.login = login
    },
    status (state,status) {
      state.status = status
    },
    errorLogin (state,status) {
      state.errorLogin = errorLogin
    },
    sessionId (state,sessionId) {
      state.sessionId = sessionId
    },
    restriction (state,restriction) {
      state.restriction = restriction
    },
    vendeur (state,vendeur) {
      state.vendeur = vendeur
    },
    connexion (state,credit) {
        console.log(credit.login)
        console.log(credit.mdp)
        var self=state
        var request = $.ajax({
            url: BACKEND_URL+"Controller/index.php",
            async: false,
            type: "POST",
            data: {
              'getSessionId': 1,
              'identifiant': credit.login,
              'mdp': credit.mdp,
              'societe':credit.societe
            },
            dataType: "html",
            success: function(data) {
                console.log(data)
                var dataParsed = JSON.parse(data)
                self.login = dataParsed.login
                self.sessionId = dataParsed.sessionId
                self.errorLogin= dataParsed.errorLogin
                self.status=true
                self.restriction=dataParsed.restriction
                self.vendeur=dataParsed.vendeur
            },
            error: function(resp) {
                console.log(resp)
                self.status=false
            }
        })

        return "ok"
      }
  },
  getters: {
    login: state => {
      return state.login
    },
    sessionId: state => {
      return state.sessionId
    },
    status: state => {
      return state.status
    },
    errorLogin: state => {
      return state.errorLogin
    },
    restriction: state =>{
      return state.restriction
    },
    vendeur: state =>{
      return state.vendeur
    }
    
  },
  plugins: [createPersistedState()],
})

//store.getters.doneTodos 
//this.$myStore.commit('increment')